import "./style.scss";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { SocialMedia } from "../../redux/definitions/types/socialmedia";
import { getSocialMedia } from "../../redux/definitions";
import { Divider, Dropdown, Nav, Sidenav } from "rsuite";
import images from "../../assets/images";

const ResponsiveFooter = () => {
  const [socialMedia, setSocialMedia] = useState<SocialMedia>({
    FacebookLink: "",
    InstagramLink: "",
    LinkedinLink: "",
    TwitterLink: "",
    YoutubeLink: "",
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getSocialMedia({
        payload: {
          onSuccess: (message, payload) => setSocialMedia(payload),
          onError: (message) => {},
        },
        url: "api/definitions/socialmedia",
      })
    );
  }, [dispatch]);

  const columns = [
    {
      title: "Oto Plan",
      link: "https://otoplan.com.tr/hakkimizda",
      subs: [
        {
          name: "Hakkımızda",
          link: "https://otoplan.com.tr/hakkimizda",
        },
      ],
    },
    {
      title: "Hizmetler",
      subs: [
        {
          name: "Operasyonel Filo Yönetim",
          link: "https://otoplan.com.tr/hizmetler#filo-kiralama",
        },
        {
          name: "Filo Yönetimi",
          link: "https://otoplan.com.tr/hizmetler#filo-yonetimi",
        },
      ],
    },
    {
      title: "Teklif Oluştur",
      link: "https://teklif.otoplan.com.tr/",
    },
    {
      title: "Satış Sonrası",

      subs: [
        {
          name: "7/24 Acil Destek",
          link: "https://otoplan.com.tr/satis-sonrasi#sec7-24-acil",
        },
        { name: "Oto Planner", link: "/" },
        {
          name: "Mobil Uygulaması",
          link: "https://www.otoplan.com.tr/mobil-uygulama",
        },
        {
          name: "Servis Noktaları",
          link: "https://otoplan.com.tr/satis-sonrasi#servis-noktalari",
        },
        {
          name: "Servis Talep Formu",
          link: "https://otoplan.com.tr/satis-sonrasi#servis-talebi",
        },
        {
          name: "Lastik Talep Formu",
          link: "https://otoplan.com.tr/satis-sonrasi#lastik-talebi",
        },
        {
          name: "Muayene Yetki Belgesi Talebi",
          link: "https://otoplan.com.tr/satis-sonrasi#myb-talebi",
        },
        {
          name: "Trafik SigortasıTalebi",
          link: "https://otoplan.com.tr/satis-sonrasi#tsp-talebi",
        },
        {
          name: "Sıkça Sorulan Sorular",
          link: "https://otoplan.com.tr/sikca-sorulan-sorular",
        },
      ],
    },
    {
      title: "2. El Araçlar",
      link: "https://www.2plan.com.tr/",
    },
    {
      title: "Haberler",
      link: "https://otoplan.com.tr/haberler",
    },
    {
      title: "İletişim",
      link: "https://otoplan.com.tr/iletisim",
    },
  ];
  return (
    <footer className="responsiveSmFooter footer  text-white footerfont">
      <div className="d-flex flex-column justify-content-center align-items-center h-100">
        <div className="container ">
          <div className="w-100 pt-4">
            <div className="text-white pt-5 pt-3 pb-4  px-0 row seven-cols">
              {columns.map((x) => (
                <div className="col-md-1 ">
                  <Sidenav
                    style={{
                      backgroundColor: "#ff4436",
                    }}
                    expanded={true}
                  >
                    <Sidenav.Body
                      className="footer-sidenav-body"
                      style={{
                        backgroundColor: "#ff4436",
                      }}
                    >
                      <Nav
                        onSelect={(e) => {
                          return window.open(e, "_blank");
                        }}
                        activeKey={"1"}
                        style={{
                          backgroundColor: "#ff4436",
                        }}
                      >
                        {x.subs ? (
                          <Dropdown
                            style={{
                              backgroundColor: "#ff4436",
                            }}
                            className={"footer-dropdown footer-link text-white"}
                            eventKey={"1"}
                            onSelect={(e) => {
                              return window.open(e, "_blank");
                            }}
                            title={x.title}
                            activeKey="1"
                            noCaret
                          >
                            {x.subs?.map((sub) => (
                              <Dropdown.Item
                                style={{
                                  backgroundColor: "#ff4436",
                                }}
                                eventKey={sub.link}
                                className="footer-dropdown-item"
                              >
                                <span> {sub.name}</span>
                              </Dropdown.Item>
                            ))}
                          </Dropdown>
                        ) : (
                          <Nav.Item
                            eventKey={x.link}
                            className=" text-white footer-navitem"
                          >
                            {x.title}
                          </Nav.Item>
                        )}
                      </Nav>
                    </Sidenav.Body>
                  </Sidenav>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-between align-items-end mt-5 pt-4 flex-wrap">
              <div>
                <a
                  href="https://otoplan.com.tr/kullanim-sartlari"
                  className="footer-small-text"
                >
                  KULLANIM ŞARTLARI VE GİZLİLİK POLİTİKASI
                </a>
                <Divider vertical />
                <a
                  href="https://otoplan.com.tr/cerez-politikasi"
                  className="footer-small-text"
                >
                  ÇEREZ POLİTİKASI
                </a>
              </div>
              <div>
                <a href={socialMedia.FacebookLink} className={"footer-link"}>
                  {"FACEBOOK"}
                </a>
                <Divider vertical />
                <a href={socialMedia.InstagramLink} className={"footer-link"}>
                  {"INSTAGRAM"}
                </a>
                <Divider vertical />
                <a href={socialMedia.TwitterLink} className={"footer-link"}>
                  {"TWITTER"}
                </a>
                <Divider vertical />
                <a href={socialMedia.LinkedinLink} className={"footer-link"}>
                  {"LINKEDIN"}
                </a>{" "}
                <Divider vertical />
                <a href={socialMedia.YoutubeLink} className={"footer-link"}>
                  {"YOUTUBE"}
                </a>
              </div>
            </div>
          </div>
        </div>
        <Divider className="w-100 my-3" />{" "}
        <div className="pb-4 container footer-small-text">
          <img
            src={images.logowhite}
            alt={""}
            width={"auto"}
            height={25}
            style={{ marginInlineEnd: 24 }}
          />{" "}
          © 2022 OTO PLAN Her hakkı saklıdır.
        </div>
      </div>
    </footer>
  );
};

export default ResponsiveFooter;
